import React, {useEffect, useState} from 'react';
import Page from "../../Components/Page";
import {LoadingWrapper} from "../../Components/LoadingWrapper";
import {makeApolloClientCall} from "../../../Api/makeApolloApiCall";
import SelectDropdown from "../../Components/Dropdowns/SelectDropdown";
import moment from "moment/moment";
import PeriodReleaseAuditChangesTable from "./PeriodReleaseAuditChangesTable";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import PeriodReleaseModal from "./PeriodReleaseModal";
import {makeApiCall} from "../../../Api/makeApiCall";

const PeriodReleaseAuditChanges = () => {

    const [periodOptions, setPeriodOptions] = useState(undefined);
    const [selectedPeriod, setSelectedPeriod] = useState(undefined);
    const [measuresStart, setMeasuresStart] = useState([]);
    const [measuresStop, setMeasuresStop] = useState([]);
    const [blockedItemCodes, setBlockedItemCodes] = useState([]);
    const [storeClosures, setStoreClosures] = useState([]);
    const [deletedData, setDeletedData] = useState([]);
    const [marketService, setMarketService] = useState([]);
    const [skipStores, setSkipStores] = useState([]);
    const [alwaysFill, setAlwaysFill] = useState([]);
    const [doNotFill, setDoNotFill] = useState([]);
    const [incomingFile, setIncomingFile] = useState([]);
    const [skipDailyFill, setSkipDailyFill] = useState([]);
    const [projectionStoreOverrides, setProjectionStoreOverrides] = useState([]);
    const [marketsServiceTwo, setMarketsServiceTwo] = useState([]);
    const [marketStores, setMarketStores] = useState([]);
    const [deletedProjectionVersions, setDeletedProjectionVersions] = useState([]);

    const [loading, setLoading] = useState(true);

    const currentDate = moment(Date.now()).format('yyyy-MM-DD');

    const getByKey = (data, key) => (data.find(config => Object.keys(config)[0] === key) || {})[key]

    function formatAuditLogs(data, configType) {
        let formatedLogs = []
        const configData = getByKey(data, configType);
        configData?.map(record => {
            const configName = Object.keys(record)[0];
            record[configName].forEach(auditEvent => {
                formatedLogs.push({...auditEvent, configName: configName});
            });
        })
        return formatedLogs
    }

    useEffect(() => {
        if (selectedPeriod) {
            setLoading(true)
            const configAuditUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/periodReleaseAuditChanges/${selectedPeriod.value}`;
            makeApiCall(configAuditUrl)
                .then(data => {
                        const measuresStartUpdated = formatAuditLogs(data, 'start_measures');
                        setMeasuresStart(measuresStartUpdated);

                        const measuresStopUpdated = formatAuditLogs(data, 'stop_measures');
                        setMeasuresStop(measuresStopUpdated);

                        const blockedItemCodesUpdated = formatAuditLogs(data, 'blocked_item_codes');
                        setBlockedItemCodes(blockedItemCodesUpdated);

                        const storeClosuresUpdated = formatAuditLogs(data, 'store_closures');
                        setStoreClosures(storeClosuresUpdated);

                        const deletedDataUpdated = formatAuditLogs(data, 'data_deleted');
                        setDeletedData(deletedDataUpdated);

                        const marketServiceUpdated = formatAuditLogs(data, 'market_service');
                        setMarketService(marketServiceUpdated);

                        const skipStoresUpdated = formatAuditLogs(data, 'skip_stores_service');
                        setSkipStores(skipStoresUpdated);

                        const alwaysFillUpdated = formatAuditLogs(data, 'always_fill_service');
                        setAlwaysFill(alwaysFillUpdated);

                        const doNotFillUpdated = formatAuditLogs(data, 'do_not_fill_service');
                        setDoNotFill(doNotFillUpdated);

                        const incomingFileUpdated = formatAuditLogs(data, 'incoming_file_service');
                        setIncomingFile(incomingFileUpdated);

                        const skipDailyFillUpdated = formatAuditLogs(data, 'skip_daily_fill_service');
                        setSkipDailyFill(skipDailyFillUpdated);

                        const projectionStoreOverridesUpdated = formatAuditLogs(data, 'projection_store_overrides');
                        setProjectionStoreOverrides(projectionStoreOverridesUpdated);

                        const marketsServiceTwoUpdated = formatAuditLogs(data, 'market_service_two');
                        setMarketsServiceTwo(marketsServiceTwoUpdated);

                        const marketStoresUpdated = formatAuditLogs(data, 'market_stores');
                        setMarketStores(marketStoresUpdated);

                        const deletedProjectionVersionsUpdated = formatAuditLogs(data, 'projection_versions_deleted');
                        setDeletedProjectionVersions(deletedProjectionVersionsUpdated);
                    }
                ).finally(() => setLoading(false))

        }
    }, [selectedPeriod, periodOptions])

    const periodDetailsQuery = "{ periods( periodEndWeeksOnly: true  ) { endDate periodAbbreviation getPriorPeriod(periodsPrior: 1, periodType: QUAD) { endDate } } }"

    useEffect(() => {
        makeApolloClientCall(periodDetailsQuery)
            .then(data => {
                    return data.periods
                        .filter((period) => period.endDate <= currentDate)
                        .map((period) => {
                            const startDate = period?.getPriorPeriod?.endDate
                            return {label: period.periodAbbreviation, value: startDate}
                        })
                }
            ).then(periodWithStartDateOfLastPeriod => setPeriodOptions(periodWithStartDateOfLastPeriod));
    }, [])


    return (<Page name={"Period Release Audit Changes"}>
        <SelectDropdown
            options={periodOptions}
            id={'period_options_dropdown'}
            inputLabel={"Period"}
            selectValue={selectedPeriod?.value}
            selectLabel={selectedPeriod?.label}
            onChange={(option) => setSelectedPeriod(option)}
        />
        <br/>
        <br/>
        {selectedPeriod && <LoadingWrapper loading={loading}>
            <div>
                <h4>{`Changes between ${selectedPeriod.value} - ${currentDate}`}</h4>
                <hr className={"draw-a-line"}/>

                <Tabs>
                    <TabList>
                        <Tab data-testid={'measures-start-tab-name'}>Measures Start</Tab>
                        <Tab data-testid={'measures-stop-tab-name'}>Measures Stop</Tab>
                        <Tab data-testid={'blocked-item-codes-tab-name'}>Blocked Item Codes</Tab>
                        <Tab data-testid={'store-closures-tab-name'}>Store Closures</Tab>
                        <Tab data-testid={'data-deleted-tab-name'}>Data Deleted</Tab>
                        <Tab data-testid={'market-service-tab-name'}>Market Service</Tab>
                        <Tab data-testid={'skip-stores-tab-name'}>Skip Stores</Tab>
                        <Tab data-testid={'always-fill-tab-name'}>Always Fill</Tab>
                        <Tab data-testid={'do-not-fill-tab-name'}>Do Not Fill</Tab>
                        <Tab data-testid={'incoming-files-tab-name'}>Incoming Files</Tab>
                        <Tab data-testid={'skip-daily-fill-tab-name'}>Skip Daily Fill</Tab>
                        <Tab data-testid={'markets-service-two-tab-name'}>Markets Service Two</Tab>
                        <Tab data-testid={'market-stores-tab-name'}>Market Stores</Tab>
                        <Tab data-testid={'projection-versions-deleted-tab-name'}>Projection Versions Deleted</Tab>
                    </TabList>
                    <TabPanel data-testid={'measures-start-tab-panel'}>
                        <PeriodReleaseAuditChangesTable
                            data={measuresStart}
                            customColumns={[
                                {header: 'Spins Store Id', accessorKey: 'storeId'},
                                {header: 'Sales End Date', accessorKey: 'salesEndDate'}
                            ]}
                            gcsFolderPath={"measures/storeStart"}
                            headerValue={"Measures Start"}
                        />
                    </TabPanel>
                    <TabPanel data-testid={'measures-stop-tab-panel'}>
                        <PeriodReleaseAuditChangesTable
                            data={measuresStop}
                            customColumns={[
                                {header: 'Spins Store Id', accessorKey: 'storeId'},
                                {header: 'Sales End Date', accessorKey: 'salesEndDate'}
                            ]}
                            gcsFolderPath={"measures/storeStop"}
                            headerValue={"Measures Stop"}
                        />
                    </TabPanel>
                    <TabPanel data-testid={'blocked-item-codes-tab-panel'}>
                        <PeriodReleaseAuditChangesTable
                            data={blockedItemCodes}
                            customColumns={[
                                {header: 'Spins Store Id', accessorKey: 'spinsStoreId'},
                                {header: 'Spins Item Code', accessorKey: 'spinsItemCode'},
                                {header: 'Sales End Date', accessorKey: 'salesEndDate'}
                            ]}
                            gcsFolderPath={"blockedItemCodes"}
                            headerValue={"Blocked Item Codes"}
                        />
                    </TabPanel>
                    <TabPanel data-testid={'store-closures-tab-panel'}>
                        <PeriodReleaseAuditChangesTable
                            data={storeClosures}
                            customColumns={[
                                {header: 'Store Id', accessorKey: 'storeId'},
                                {header: 'Start Date', accessorKey: 'startDate'},
                                {header: 'End Date', accessorKey: 'endDate'}
                            ]}
                            gcsFolderPath={"storeClosures"}
                            headerValue={"Store Closures"}
                        />
                    </TabPanel>
                    <TabPanel data-testid={'data-deleted-tab-panel'}>
                        <PeriodReleaseAuditChangesTable
                            data={deletedData}
                            customColumns={[
                                {header: 'Store Id', accessorKey: 'store_id'},
                                {header: 'Date', accessorKey: 'date_string'}
                            ]}
                            gcsFolderPath={"deleteRetailerJsonByDate"}
                            headerValue={"Data Deleted"}
                        />
                    </TabPanel>
                    <TabPanel data-testid={'market-service-tab-panel'}>
                        <PeriodReleaseAuditChangesTable
                            data={marketService}
                            customColumns={[
                                {
                                    header: 'Record',
                                    accessorKey: 'record',
                                    cell: ({row}) => <PeriodReleaseModal row={row.original}/>
                                }
                            ]}
                            gcsFolderPath={"market/periods"}
                            headerValue={"Market Service"}
                        />
                    </TabPanel>
                    <TabPanel data-testid={'skip-stores-tab-panel'}>
                        <PeriodReleaseAuditChangesTable
                            data={skipStores}
                            customColumns={[
                                {header: 'Store ID', accessorKey: 'storeId'},
                                {header: 'Alerts', accessorKey: 'skipAlerts'},
                                {header: 'Cleanse Fill Spotlight', accessorKey: 'skipCleanseFillSpotlight'},
                                {header: 'Fill', accessorKey: 'skipFill'},
                                {header: 'Missing Days', accessorKey: 'skipMissingDays'},
                                {header: 'Missing Weeks', accessorKey: 'skipMissingWeeks'},
                                {header: 'Outlier', accessorKey: 'skipOutlier'},
                                {header: 'Store Insights', accessorKey: 'skipStoreInsights'},
                                {header: 'Market Insights', accessorKey: 'skipMarketInsights'},
                                {header: 'Store Totals', accessorKey: 'skipStoreTotals'}
                            ]}
                            gcsFolderPath={"skipStores"}
                            headerValue={"Skip Stores"}
                        />
                    </TabPanel>
                    <TabPanel data-testid={'always-fill-tab-panel'}>
                        <PeriodReleaseAuditChangesTable
                            data={alwaysFill}
                            customColumns={[
                                {header: 'Spins Store Id', accessorKey: 'storeId'},
                                {header: 'Sales End Date', accessorKey: 'salesEndDate'}
                            ]}
                            gcsFolderPath={"fill/alwaysFill"}
                            headerValue={"Always Fill"}
                        />
                    </TabPanel>
                    <TabPanel data-testid={'do-not-fill-tab-panel'}>
                        <PeriodReleaseAuditChangesTable
                            data={doNotFill}
                            customColumns={[
                                {header: 'Spins Store Id', accessorKey: 'storeId'},
                                {header: 'Sales End Date', accessorKey: 'salesEndDate'}
                            ]}
                            gcsFolderPath={"fill/doNotFill"}
                            headerValue={"Do Not Fill"}
                        />
                    </TabPanel>
                    <TabPanel data-testid={'incoming-files-tab-panel'}>
                        <PeriodReleaseAuditChangesTable
                            data={incomingFile}
                            customColumns={[
                                {header: 'File Name', accessorKey: 'record'},
                            ]}
                            gcsFolderPath={"incomingFiles/periods"}
                            headerValue={"Incoming Files"}
                        />
                    </TabPanel>
                    <TabPanel data-testid={'skip-daily-fill-tab-panel'}>
                        <PeriodReleaseAuditChangesTable
                            data={skipDailyFill}
                            customColumns={[
                                {header: 'Spins Retailer Id', accessorKey: 'retailerId'},
                                {header: 'Spins Store Id', accessorKey: 'storeId'},
                                {header: 'Week End Date', accessorKey: 'salesEndDate'}
                            ]}
                            gcsFolderPath={"skipDailyFill"}
                            headerValue={"Skip Daily Fill"}
                        />
                    </TabPanel>
                    <TabPanel data-testid={'markets-service-two-tab-panel'}>
                        <PeriodReleaseAuditChangesTable
                            data={marketsServiceTwo}
                            customColumns={[
                                {header: "Market Id", accessorKey: "marketId"},
                                {header: "Market Tag", accessorKey: "marketTag"},
                                {header: "Description", accessorKey: "description"},
                                {header: "Level", accessorKey: "level"},
                                {header: "Sne Flag", accessorKey: "sneFlag"},
                                {header: "Order Number", accessorKey: "orderNumber"},
                                {header: "Store Level", accessorKey: "isStoreLevel"},
                                {header: "Control Brand Build", accessorKey: "controlBrandBuild"},
                                {header: "SVC Name", accessorKey: "svcName"},
                                {header: "SCV Growth Factor", accessorKey: "scvGrowthFactor"},
                                {header: "Store Count Growth Factor", accessorKey: "storeCntGrowthFactorOverride"}
                            ]}
                            gcsFolderPath={"marketsTwo"}
                            headerValue={"Markets Service Two"}
                        />
                    </TabPanel>
                    <TabPanel data-testid={'market-stores-tab-panel'}>
                        <PeriodReleaseAuditChangesTable
                            data={marketStores}
                            customColumns={[
                                {header: "Market Id", accessorKey: "marketId"},
                                {header: "Store Id", accessorKey: "storeId"},
                            ]}
                            gcsFolderPath={"marketStores"}
                            headerValue={"Market Stores"}
                        />
                    </TabPanel>
                    <TabPanel data-testid={'projection-versions-deleted-tab-panel'}>
                        <PeriodReleaseAuditChangesTable
                            data={deletedProjectionVersions}
                            customColumns={[
                                {header: "Version", accessorKey: "version"},
                            ]}
                            gcsFolderPath={"deleteProjectionVersion"}
                            headerValue={"Projection Versions Deleted"}
                        />
                    </TabPanel>
                </Tabs>
            </div>
        </LoadingWrapper>}

    </Page>);
};


export default PeriodReleaseAuditChanges;